<template>
  <div class="deskblock">
    <h3 style="margin-bottom: 10px">最近7天报警消息Top50</h3>
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="540"
    >
    </Table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "车牌号",
          key: "name",
        },
        {
          title: "报警类型",
          key: "alarmTypeName",
        },
        {
          title: "详细信息",
          key: "info",
        },
        {
          title: "报警时间",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
        },
      ],
      tableData: [],
      searchItem: {
        startTime: "",
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
      },
    };
  },
  methods: {
    getData() {

      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarm/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          for (let i = 0; i < data.length; i++) {
            data[i].name = aa([data[i].carNo, data[i].personName]);
            //personName
          }
          this.tableData = data;
          function aa(t) {
            for (let j = 0; j < t.length; j++) {
              if (t[j] != null) {
                return t[j];
              }
            }
          }
        }
      });
    },

    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();
      this.searchItem.startTime = new Date(
        this.yy,
        this.mm,
        this.dd - 6
      ).getTime();
      this.searchItem.endTime =
        new Date(this.yy, this.mm, this.dd+1).getTime() - 1000;
      this.getData();
    },
  },
  //调用
  mounted() {
    this.defaultTime();
  },
};
</script>
<style lang="">
#bar2 {
  width: 100%;
  height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/workDesk/allData/block2.vue